import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/admin`;

// Old implementation - commented out as backend sends all items by default
// export const listAll = (
//   facilityIds,
//   name,
//   pageSize,
//   pageNo,
//   sortFitler,
//   sortOrder
// ) => {
//   let url =
//     PREFIX +
//     `?name=${encodeURIComponent(
//       name
//     )}&sortKey=${sortFitler}&page=${pageNo}&size=${pageSize}&sortOrder=${sortOrder}`;
//
//   if (facilityIds.length > 0) {
//     url = url + `&facilityIds=${facilityIds}`;
//   }
//   return axiosInstance.get(url);
// };

// Simplified implementation - backend sends all items without pagination params
export const listAll = () => {
  return axiosInstance.get(PREFIX);
};

export const saveAdmin = data => {
  return axiosInstance.post(
    PREFIX +
      `?isFacilityAccessAllowed=${
        data?.isFacilityAccessAllowed ? data?.isFacilityAccessAllowed : false
      }`,
    data
  );
};

export const editAdmin = (data, params = {}) => {
  return axiosInstance.put(PREFIX, data, {
    params: {
      isFacilityAccessAllowed: data?.isFacilityAccessAllowed ? data?.isFacilityAccessAllowed : false,
      ...params
    }
  });
};

export const disableFacility = facilityId => {
  return axiosInstance.put(PREFIX + `/${facilityId}?isDisabled=true`);
};

export const enableFacility = facilityId => {
  return axiosInstance.put(PREFIX + `/${facilityId}?isDisabled=false`);
};

export const deleteAdmin = id => {
  return axiosInstance.delete(PREFIX + `/${id}`);
};
